import React, { useState } from 'react';
import { QuickLink } from '../types';
import Modal from './Modal';

interface LeaderboardModalProps {
    onClose: () => void;
    onSave: (link: Omit<QuickLink, 'id'>) => void;
}

const LeaderboardModal: React.FC<LeaderboardModalProps> = ({ onClose, onSave }) => {
    const [title, setTitle] = useState('');
    const [url, setUrl] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (title.trim() === '' || url.trim() === '') {
            alert("Title and URL are required.");
            return;
        }

        let validUrl = url;
        if (!validUrl.startsWith('http')) {
            validUrl = `https://${validUrl}`;
        }

        try {
            const urlObj = new URL(validUrl);
            const favicon = `https://www.google.com/s2/favicons?sz=64&domain=${urlObj.hostname}`;
            onSave({ title, url, favicon });
        } catch (_) {
            alert("Please enter a valid URL.");
            return;
        }

        onClose();
    };

    return (
        <Modal onClose={onClose} maxWidth="max-w-md">
            <div className="p-6 md:p-8">
                <h2 className="text-2xl font-bold mb-6 text-light">Add Leaderboard</h2>
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <div>
                            <label htmlFor="lb-title" className="block text-sm font-medium text-medium mb-1">Title</label>
                            <input
                                id="lb-title"
                                name="lb-title"
                                type="text"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                className="w-full bg-white/70 border-slate-300 text-light rounded-md p-2 focus:ring-accent focus:border-accent"
                                placeholder="e.g., Ranking"
                                required
                                autoFocus
                            />
                        </div>
                        <div>
                            <label htmlFor="lb-url" className="block text-sm font-medium text-medium mb-1">URL</label>
                            <input
                                id="lb-url"
                                name="lb-url"
                                type="text"
                                value={url}
                                onChange={(e) => setUrl(e.target.value)}
                                className="w-full bg-white/70 border-slate-300 text-light rounded-md p-2 focus:ring-accent focus:border-accent"
                                placeholder="example.com"
                                required
                            />
                        </div>
                    </div>
                    <div className="mt-8 flex justify-end space-x-3">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-slate-200 hover:bg-slate-300 text-light font-bold rounded-lg transition-colors">
                            Cancel
                        </button>
                        <button type="submit" className="px-4 py-2 bg-accent hover:bg-fuchsia-600 text-white font-bold rounded-lg transition-colors">
                            Save Link
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default LeaderboardModal;
